// app/(lib)/actions/aboutAction.ts
"use server";

import { aboutService } from "../services/aboutService";
import { extractDomain, getGlobalParams } from "../utils/domain";

/**
 * Fetch about page content from API
 * Called once during SSR - data is passed down to all child components
 */
export async function getAboutPageDataAction() {
  try {
    const domain = await extractDomain();
    const { franchiseeId, lang } = await getGlobalParams();


    const aboutPageData = await aboutService.fetchByDomain(domain, franchiseeId, lang);

    return {
      success: true,
      data: aboutPageData,
    };
  } catch (error) {
    console.error("[getAboutPageDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
